/**
 * Chuỗi hiển thị của nhóm màn hình lịch phát, nhật ký phát và thống kê (nhóm B,
 * dựng lại theo bản mẫu CMS). Chuỗi dùng chung đã có trong `vi.ts` thì dùng lại,
 * không khai báo trùng ở đây.
 */
export const viLichNhatKy = {
  chung: {
    diaBan: 'Địa bàn',
    donViHanhChinh: 'Đơn vị hành chính',
    toanTinh: 'Toàn tỉnh',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    xuatExcel: 'Xuất Excel',
    dangXuat: 'Đang xuất...',
    taiVe: 'Tải tệp về',
    xuatLoi: 'Xuất tệp không thành công',
    taiLaiDanhSach: 'Tải lại danh sách',
    themMoiLich: 'Thêm mới lịch',
    tongBanGhi: 'Tổng {so} bản ghi',
    khongCoDuLieuCot: 'Chưa có dữ liệu',
    tatCa: 'Tất cả',
    chon: 'Chọn',
  },
  /** Chuỗi của bảng lịch phát mẫu (trang lịch phát bảng tin dùng lại tiêu đề cột, ô lọc). */
  lichPhat: {
    tenLich: 'Tên lịch',
    nhapTenLich: 'Nhập tên lịch phát',
    trangThai: 'Trạng thái',
    chonTrangThai: 'Chọn trạng thái',
    cot: {
      moRong: 'Chi tiết',
      stt: 'STT',
      ngayTao: 'Ngày tạo',
      tenLich: 'Tên lịch',
      trangThai: 'Trạng thái',
      diaBan: 'Địa bàn',
      thietBi: 'Thiết bị',
      ngayPhat: 'Ngày phát',
      nguoiTao: 'Người tạo',
      thaoTac: 'Thao tác',
    },
  },
  lichTuan: {
    tieuDe: 'Lịch phát thanh',
    gio: 'Giờ',
    xemDangDanhSach: 'Xem dạng danh sách',
  },
  /** Nhật ký lịch phát thiết bị (`/lich-phat/nhat-ky-gui`) — gói DV006 thiết bị báo đã nhận lịch. */
  nhatKyGuiLich: {
    tieuDe: 'Nhật ký lịch phát thiết bị',
    cot: {
      stt: 'STT',
      tenLich: 'Tên lịch phát',
      diaBan: 'Địa bàn',
      maDiaBan: 'Mã địa bàn',
      soBanTin: 'Số lượng bản tin',
      thoiDiemGui: 'Thời điểm gửi lịch',
    },
    maLich: 'Mã lịch: {ma}',
    thietBi: 'Thiết bị: {ten}',
    timTheoTenMa: 'Tìm theo tên hoặc mã lịch',
    nhapTenMa: 'Nhập tên hoặc mã lịch',
    tim: 'Tìm',
    boTim: 'Bỏ tìm',
    goiYKhoangNgay: 'Lọc theo thời điểm thiết bị báo đã nhận lịch',
    rongMoTa: 'Chưa có thiết bị nào báo đã nhận lịch phát trong phạm vi lọc.',
    xuatExcel: 'Xuất Excel',
    dangXuat: 'Đang xuất…',
    xuatXong: 'Đã xuất {so} dòng.',
    xuatVuotGioiHan:
      'Kết quả có {tong} dòng, vượt giới hạn {gioiHan} dòng: tệp chỉ gồm {so} dòng đầu. Hãy thu hẹp bộ lọc.',
    xuatLoi: 'Xuất tệp không thành công: {loi}',
    xuatRong: 'Không có dòng nào để xuất.',
  },
  nhatKyHuy: {
    tieuDe: 'Nhật ký hủy lịch phát',
    cot: {
      stt: 'STT',
      thoiDiemHuy: 'Thời điểm hủy',
      tenLich: 'Tên lịch',
      maLich: 'Mã lịch',
      diaBan: 'Địa bàn',
      thietBi: 'Thiết bị',
      ngayPhat: 'Ngày phát',
      nguoiTao: 'Người tạo',
    },
    goiYKhoangNgay: 'Lọc các lịch đã hủy có ngày phát nằm trong khoảng ngày này',
    rongMoTa: 'Chưa có lịch phát nào bị hủy.',
  },
  ngheLai: {
    tieuDe: 'Nhật ký bản tin đã phát',
    loaiBanTin: 'Loại bản tin',
    chonLoaiBanTin: 'Chọn loại bản tin',
    mucDoUuTien: 'Mức độ ưu tiên',
    chonMucDoUuTien: 'Chọn mức độ ưu tiên',
    linhVuc: 'Lĩnh vực',
    chonLinhVuc: 'Chọn lĩnh vực',
    cot: {
      stt: 'STT',
      tenBanTin: 'Tên bản tin',
      thoiGianPhat: 'Thời gian phát',
      thietBiPhat: 'Thiết bị phát',
      diaBanPhat: 'Địa bàn phát',
      trangThai: 'Trạng thái',
      thoiLuong: 'Thời lượng',
      mucDoUuTien: 'Mức độ ưu tiên',
      loaiBanTin: 'Loại bản tin',
      linhVuc: 'Lĩnh vực',
      nguon: 'Nguồn kích hoạt',
      nghe: 'Nghe/Xem bản tin',
    },
    ketQua: { thanh_cong: 'Đã phát', loi: 'Lỗi phát', bi_dung: 'Bị dừng' } as Record<string, string>,
    nguonKichHoat: {
      lich: 'Theo lịch',
      phat_ngay: 'Phát ngay',
      khan_cap: 'Khẩn cấp',
      trung_uong: 'Trung ương',
      truc_tiep: 'Trực tiếp',
      tiep_song: 'Tiếp sóng',
      tiep_am: 'Tiếp âm',
    } as Record<string, string>,
    nghe: 'Nghe',
    ngheBanTin: 'Nghe lại {ten}',
    dangXuatExcel: 'Đang xuất…',
    daXuatExcel: 'Đã xuất {so} dòng ra tệp Excel.',
    xuatVuotGioiHan: 'Kết quả có {tong} dòng, tệp chỉ gồm {so} dòng đầu. Hãy thu hẹp bộ lọc.',
    xuatRong: 'Không có dòng nào để xuất.',
    loiXuatExcel: 'Không xuất được Excel: {loi}',
  },
  thongKe: {
    tieuDeLoa: 'Danh sách đài truyền thanh',
    coCntt: 'Có ứng dụng CNTT',
    chuaCntt: 'Chưa ứng dụng CNTT',
    tyLeCntt: '{co} trên {tong} xã, phường có đài ứng dụng CNTT',
    thuGon: 'Thu gọn',
    moRong: 'Mở rộng',
    rongDai: 'Chưa có xã, phường nào trong phạm vi quản lý.',
    tenTepDai: 'danh-sach-dai-truyen-thanh-{ngay}.csv',
    tieuDeBang: 'Thống kê thiết bị theo địa bàn',
    tenTepBang: 'thong-ke-bang-dien-tu-theo-dia-ban-{ngay}.csv',
    bangTheoDiaBan: 'Thống kê theo địa bàn',
    cot: {
      donVi: 'Đơn vị hành chính',
      daiCntt: 'Đài ứng dụng CNTT',
      tongThietBi: 'Tổng số thiết bị',
      dangKetNoi: 'Thiết bị đang kết nối',
      matKetNoi: 'Thiết bị đang mất kết nối',
      tongBanTin: 'Tổng số bản tin đã phát',
    },
    tongCong: 'Tổng cộng: {so} thiết bị',
    ghiChuSoThietBi:
      'Tổng số thiết bị là số thiết bị có ghi nhận trạng thái trong khoảng thời gian thống kê, gồm mọi loại thiết bị.',
    phanTichChiTiet: 'Phân tích chi tiết',
  },
  lichBangTin: {
    tieuDe: 'Lịch phát bảng tin',
  },
} as const;
